const catgoryOptions = [
  'Mountain',
  'Beach',
  'City',
  'Snow',
  'Extreme'
]

export default catgoryOptions;

